import Entity from "./Entity";

export default class OSMTile extends Entity {
    constructor(x, y, zoom) {
        super({
            x: x,
            y: y,
            zoom: zoom
        });

        self.attributeKeys = [ "x", "y", "zoom" ];
    }
}